import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { Comprobante } from '../../../models/comprobante';
import { ComprobanteService } from '../../../services/comprobante.service';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { SessionService } from '../../../services/session.service';
import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';

import { CajaService } from '../../../services/caja.service';
import { Block } from '../../../models/block';

declare var $;

@Component({
	selector: 'app-comprobante-add',
	templateUrl: './comprobante-add.component.html',
	styleUrls: ['./comprobante-add.component.css'],
	providers: [ComprobanteService,CajaService,TipoComprobanteService,SessionService]
})
export class ComprobanteAddComponent implements OnInit {
	public title: String;
	public comprobante:Comprobante;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public cajas;
	public tipos;
	public blocks: Array<Block> = [];
	public enabledButton:boolean= false;
	private validDateEmision;
	private block: Block;
	private validDateCaducidad;
	closeResult: string;
	public loading = false;

	constructor(
		private ComprobanteService: ComprobanteService,
		private tipoComprobanteService: TipoComprobanteService,
		private cajaService: CajaService,
		public fb: FormBuilder,
		private ss: SessionService,
	) {
		this.title = "Registrar";
	}

	ngOnInit() {
		this.block = new Block();
		//Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Comprobante
		this.comprobante = new Comprobante();
		this.tipos = [];
		this.getCaja();
		this.getTipoComprobante();
		
	}

	getCaja(){
		this.loading = true;
		this.cajaService.getAll().subscribe(
			res =>{
				this.loading = false;
				this.cajas = res.data;
			},
			err =>{
				this.loading = false;
				this.cajas=[];
			});
	}

	sendBlock(event) {
		this.blocks.push(event);
		this.myForm.patchValue({
			secuencial: event.secuencial_inicio
		});
	}


	getTipoComprobante(){
		this.loading = true;
		this.tipoComprobanteService.getAll().subscribe(
			res =>{
				this.loading = false;
				this.tipos = res.data;
			},
			err =>{
				this.loading = false;
				this.tipos=[];
			});
	}

	onEnabledButton(){
		if(this.blocks.length > 0)
			return this.enabledButton = true;
		else
			return this.enabledButton = false;
	}

	onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.ComprobanteService.save(this.comprobante).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
				this.comprobante = new Comprobante();
				this.onDelete();
				this.onForm();
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
	}

	openDialog(){
		$("#block-modal").appendTo("body").modal("show");
		//$("#block-modal").modal("show");
	}

	onForm() {
		this.myForm = this.fb.group({
			secuencial: [{value:'',disabled:false}, 
			[Validators.required]],
			caja_id: ['', [Validators.required]],
			tipo_comprobante_id: ['', [Validators.required]],
			secuencial_inicial: ['', [Validators.required, Validators.pattern(/[0-9]/)]],
			secuencial_fin: ['', [Validators.required, Validators.pattern(/[0-9]/)]],
			fecha_caducidad: [new Date().toISOString().substring(0,10), [Validators.required]],
			fecha_emision: [new Date().toISOString().substring(0,10) , [Validators.required]],
			numero_autorizacion: ['',[Validators.required]]
		});
	}

	setValueEntity(){
		this.comprobante.secuencial = this.myForm.controls['secuencial'].value;
		this.comprobante.caja_id = this.myForm.controls['caja_id'].value;
		this.comprobante.tipo_comprobante_id = this.myForm.controls['tipo_comprobante_id'].value;
		this.comprobante.empresa_id = this.ss.getData('empresa_id');
		this.comprobante.sucursal_id = this.ss.getData('sucursal_id');
		this.comprobante.usuario_id = this.ss.getData('usuario_id');

		this.block.fecha_emision = this.myForm.controls['fecha_emision'].value;
		this.block.numero_autorizacion = this.myForm.controls['numero_autorizacion'].value;
		this.block.fecha_caducidad = this.myForm.controls['fecha_caducidad'].value;
		this.block.secuencial_inicio = this.myForm.controls['secuencial_inicial'].value;
		this.block.secuencial_fin = this.myForm.controls['secuencial_fin'].value;		
		this.block.empresa_id = this.ss.getData('empresa_id');
		this.block.sucursal_id = this.ss.getData('sucursal_id');
		this.block.usuario_id = this.ss.getData('usuario_id');

		this.comprobante.blocks.push(this.block);
	}

	onValidDateEmision() {
		this.block.fecha_emision = this.myForm.controls['fecha_emision'].value;
		this.validDateEmision = this.vl.validDateYYYY(this.block.fecha_emision.toString());
		return this.validDateEmision;
	}

	onValidDateCaducidad() {
		this.block.fecha_caducidad = this.myForm.controls['fecha_caducidad'].value;
		this.validDateCaducidad = this.vl.validDateYYYY(this.block.fecha_caducidad.toString());
		return this.validDateCaducidad;
	}

	validErrorForm(campo){
		return this.vl.validErrorForm(campo,this.myForm);
	}

	validTypeMsgForm(nombre,campo){
		return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
	}

	onDelete(){
		this.blocks = [];
		this.myForm.patchValue({
			secuencial: ""
		});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/comprobante-add/comprobante-add.component.ts